import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
export var PolygonDrawerBase = /*#__PURE__*/function () {
  function PolygonDrawerBase() {
    _classCallCheck(this, PolygonDrawerBase);
  }
  _createClass(PolygonDrawerBase, [{
    key: "getSidesCount",
    value: function getSidesCount(particle) {
      var _a, _b;
      var polygon = particle.shapeData;
      return (_b = (_a = polygon === null || polygon === void 0 ? void 0 : polygon.sides) !== null && _a !== void 0 ? _a : polygon === null || polygon === void 0 ? void 0 : polygon.nb_sides) !== null && _b !== void 0 ? _b : 5;
    }
  }, {
    key: "draw",
    value: function draw(context, particle, radius) {
      var start = this.getCenter(particle, radius);
      var side = this.getSidesData(particle, radius);
      var sideCount = side.count.numerator * side.count.denominator;
      var decimalSides = side.count.numerator / side.count.denominator;
      var interiorAngleDegrees = 180 * (decimalSides - 2) / decimalSides;
      var interiorAngle = Math.PI - Math.PI * interiorAngleDegrees / 180;
      if (!context) {
        return;
      }
      context.beginPath();
      context.translate(start.x, start.y);
      context.moveTo(0, 0);
      for (var i = 0; i < sideCount; i++) {
        context.lineTo(side.length, 0);
        context.translate(side.length, 0);
        context.rotate(interiorAngle);
      }
    }
  }]);
  return PolygonDrawerBase;
}();